<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td
      v-for="filter in filters"
      :key="filter.field"
      class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
    >
      <v-text-field
        v-if="filter.type === 'text'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        type="text"
        @keyup.enter="resetToFirstPage"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearFilterData(filter.field)"
      />
    </td>
  </tr>
</template>

<script>

export default {
  props: ['search', 'options'],
  data() {
    return {
      filters: [
        { label: '', field: '', type: '' },
        { label: 'Nama Merchant', field: 'merchant_name', type: 'text' },
        { label: 'MID', field: 'mid', type: 'text' },
        { label: 'Email', field: 'email', type: 'text' },
        { label: 'Kode Pos', field: 'postal_code', type: 'text' },
      ],
    };
  },
  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
  },

  beforeDestroy() {
    this.resetFilters();
  },
  methods: {
    resetFilters() {
      Object.keys(this.searchData).forEach(key => {
        this.searchData[key] = '';
      });
    },
    clearFilterData(field) {
      this.suppressWatch = true;

      this.searchData[field] = '';

      this.$nextTick(() => {
        this.suppressWatch = false;
        this.resetToFirstPage();
      });
    },

    resetToFirstPage() {
      this.$emit('update:options', {
        ...this.options,
        page: 1,
      });
    },
    getData() {
      const newOptions = { ...this.options, page: 1 };
      this.$emit('update:options', newOptions);
      this.$emit('getDataParent');
    },
  },
};
</script>